import type { INotification, NotificationPriority } from '@pulse/shared';
import type { Notification, NotificationVariant } from '@pulse/ui';

import { htmlToPlainText } from '../../../lib/html-to-text.util';

// The one place that bridges the backend's INotification (id, recipientId, priority, event, ...)
// to @pulse/ui's presentational Notification shape (id, timestamp, read, variant, ...) — every
// other component (NotificationContext, NotificationsPage) goes through this instead of
// building panel props by hand, so the two shapes only ever get mapped one way.
const PRIORITY_VARIANT: Record<NotificationPriority, NotificationVariant> = {
  urgent: 'error',
  high: 'warning',
  normal: 'info',
  low: 'info',
};

export function toUiNotification(notification: INotification, onNavigate: (path: string) => void): Notification {
  return {
    id: notification.id,
    title: notification.title,
    // notification.message is rendered HTML (see InAppChannel.resolveContent) — the panel's
    // NotificationItem (@pulse/ui) renders this as plain text (no HTML renderer, and it stays
    // app-agnostic on purpose), and the panel is a compact preview anyway; the full template
    // only ever renders as HTML in NotificationDetailDialog, opened via this same actionUrl.
    message: htmlToPlainText(notification.message),
    timestamp: notification.createdAt,
    read: !!notification.readAt,
    variant: PRIORITY_VARIANT[notification.priority],
    actionLabel: notification.actionUrl ? 'View' : undefined,
    onAction: notification.actionUrl ? () => onNavigate(notification.actionUrl!) : undefined,
  };
}
